import type { FC } from "react";
import { memo } from "react";

import Tag from "@Components/Icons/Tag";
import ImageLoader from "@Components/ImageLoader";
import type { ILink } from "@Components/Link";
import type { IMapMarker as IMapMarkerComp } from "@Components/Map/MapMarker";
import { defaultToTrue } from "@Components/Modules/Helpers";

import { TransitionLink } from "../common/Transition";

import * as css from "./MapMarker.module.css";

export enum MarkerType {
    Default,
    ShoppingMall,
    Brand,
}

export interface IMapMarker extends IMapMarkerComp {
    markerType: MarkerType;
    info: IMapMarkerInfo;
}

export interface IMapMarkerInfo {
    imageUrl: string;
    name: string;
    address: string;
    allOffers: ILink;
}

export const logo = ({ imageUrl }: IMapMarkerInfo) =>
    imageUrl && <ImageLoader className={css.logo} src={imageUrl} lazyLoading={false} />;

export const name = (props: IMapMarkerInfo) => props.name && <div className={css.name}>{props.name}</div>;

export const address = (props: IMapMarkerInfo) =>
    props.address && <div className={css.address} dangerouslySetInnerHTML={{ __html: props.address }} />;

export const offersLink = ({ allOffers }: IMapMarkerInfo) =>
    allOffers && (
        <span className={css.goToOffers}>
            <Tag />
            <TransitionLink {...allOffers} />
        </span>
    );

export const MapMarkerInfo: FC<IMapMarkerInfo> = memo(
    (props) => (
        <div className={css.mapMarkerInfoComponent}>
            {logo(props)}
            {name(props)}
            {address(props)}
            {offersLink(props)}
        </div>
    ),
    defaultToTrue,
);
